import React, { createContext } from 'react';
import PropTypes from 'prop-types';

import { useQuery } from '@apollo/react-hooks';
import { GET_SNAPFLOW_LINKS } from '../../../network/queries';

export const SnapFlowContext = createContext({});

export const SnapFlowProvider = ({ vpn, children }) => {
  const { loading: queryLoading, error: queryError, data: queryData } = useQuery(
    GET_SNAPFLOW_LINKS,
    {
      variables: { vpn },
    },
  );

  const contextData = {
    requestData: {
      queryLoading,
      queryError,
      queryData,
    },
  };

  return <SnapFlowContext.Provider value={{ contextData }}>{children}</SnapFlowContext.Provider>;
};

SnapFlowProvider.propTypes = {
  vpn: PropTypes.string.isRequired,
  children: PropTypes.oneOfType([PropTypes.arrayOf(PropTypes.node), PropTypes.node]).isRequired,
};
